var mfaFactory = function ($resource, $window) {
  var createAndDeliverActivationCodeApi =
    "rest/partialauth/mfa/createAndDeliverActivationCode/:deliveryOption";
  var createAndDeliverActivationCodePOSTApi =
    "rest/partialauth/mfa/createAndDeliverActivationCode";
  var verificationCodeApi = "rest/partialauth/mfa/verifycode";
  var flowName = "";

  return {
    createAndDeliverActivationCode: $resource(
      __authenticationUrl__ + createAndDeliverActivationCodeApi,
      {},
      {
        deliveryOption: "@deliveryOption",
        accu: "@accu",
      },
      {
        query: {
          method: "GET",
          isArray: false,
          responseType: "json"
        },
      }
    ),

    createAndDeliverActivationCodePOST: $resource(
      __authenticationUrl__ + createAndDeliverActivationCodePOSTApi,
      {},
      {
        query: {
          method: "POST",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }
    ),

    getDeliveryOptions: $resource(
      __authenticationUrl__ + "rest/partialauth/mfa/deliveryOptions",
      {
        flowName: "@flowName",
      },
      {
        query: {
          method: "GET",
          isArray: false
        },
      }
    ),

    verifyCode: $resource(
      __authenticationUrl__ + verificationCodeApi,
      {},
      {
        query: {
          method: "POST",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }
    ),
  };
};

mfaFactory.$inject = ["$resource", "$window"];
export default mfaFactory;
